import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { CardComponent } from '../../../../components/card/card.component';

@Component({
    selector: 'lib-profile-card',
    imports: [CommonModule, CardComponent],
    templateUrl: './profile-card.component.html',
    styleUrl: './profile-card.component.css'
})
export class ProfileCardComponent {
    @Input() title: string = '';
}
